import { convertEthToWei, convertOctToAptos, convertWeiToEth, WEI_CONVERSION_RATE } from '@pkg/utils';

import { Currency, type CurrencyConversionRate } from '@app/client/common/structs/nft/currencies';

// WARNING: This file is outdated!
// All relevant code has been moved to `convert.ts` in `@pkg/utilities`.

export { WEI_CONVERSION_RATE, convertWeiToEth, convertEthToWei };
export const DEFAULT_ETH_MAX_DECIMALS = 4;

// WARNING: Consumer's should instead use
// `convertCurrency()` from `useExchangeRatesStore()`.
export function legacyConvertCurrency(
    amount: number,
    from: Currency,
    to: Currency,
    currencyConversionRate?: CurrencyConversionRate,
) {
    if (from === Currency.OCT && to === Currency.APT) {
        return convertOctToAptos(amount, DEFAULT_ETH_MAX_DECIMALS);
    }

    if (from === Currency.WEI && to === Currency.ETH) {
        return convertWeiToEth(amount, DEFAULT_ETH_MAX_DECIMALS);
    }

    if (currencyConversionRate) {
        const conversionRate = currencyConversionRate[from];
        if (conversionRate) return conversionRate[to] * amount;
    }

    return null;
}
